import { createFileRoute } from '@tanstack/react-router'
import { Library } from 'lucide-react'
import { z } from 'zod'
import { CompanyBrainScreen } from '@/screens/workspace/SCR-009-company-brain'

export const Route = createFileRoute('/_app/w/$ws/company-brain')({
  staticData: { screen: {"id":"SCR-009","title":"Company brain","group":"Workspace","perm":"memory.read","order":9,"description":"Verified knowledge cards the whole organisation can rely on.", icon: Library } },
  validateSearch: z.object({
    q: z.string().max(200).optional(),
    state: z.enum(['verified', 'stale', 'invalidated']).optional(),
    category: z.string().max(80).optional(),
    due: z.enum(['due', 'soon']).optional(),
  }),
  component: CompanyBrainScreen,
})
